(function($) {





    $(document).ready(function() {

        //plugin für dataTable https://datatables.net/plug-ins/api/sum()
        jQuery.fn.dataTable.Api.register('sum()', function() {
            return this.flatten().reduce(function(a, b) {

                // console.log('a:' + a);
                // console.log('b:' + b);

                if (typeof a === 'string') {
                    a = a.replace(/[^\d.-]/g, '') * 1;
                }
                if (typeof b === 'string') {
                    b = b.replace(/[^\d.-]/g, '') * 1;
                }

                return a + b;
            }, 0);
        });

        $.fn.editable.defaults.mode = 'inline';

        initTableShoppingCard()

        // selectPicker Tab 'Letzte Produkte/Bestellung'
        selectPicker();

        // Zellen bearbeiten - muss vor den DataTables getriggert werden
        xEditable();

        // Zellen bearbeiten - muss vor den DataTables getriggert werden
        initTableMyProducts();
        initTableAllProducts();
        initTableLastProducts();
        initTableSpecialProducts();

        // Zeile zum Warenkorb hinzufügen
        addTableRowToCard();

        // Zeile aus dem Warenkorb entfernen
        removeTableRowFromCard();

        // Auswahl letzte Warenkörbe
        getOrderData();

        // Warenkorb absenden
        setOrderData();

        // Lieferdatum Datepicker
        initDateTimePicker();





        // trigger responsive dataTable on tab change
        // trigger xEdible on tab change
        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {

            $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
            $.fn.dataTable.tables({ visible: true, api: true }).responsive.recalc();

        });

    });

    function selectPicker() {

        // https://silviomoreto.github.io/bootstrap-select/

        $('[data-select="last-orders"]').selectpicker({
            style: 'btn-primary'
        });
    }

    function initAddAllToCardButton() {


        $('[data-onclick="add-current-list-to-card"]').click(function(e) {

            var currentListData, data, rowNode, emptyString;

            e.stopImmediatePropagation();

            tableLastProducts.rows().every(function(rowIdx, tableLoop, rowLoop) {

                data = this.data();
                // rowNode = this.node();

                // dörty but wörks! ¯\_(ツ)_/¯
                emptyString = data[3].replace('>Menge in Stück<', '><');
                emptyString = emptyString.replace('>Menge in Kg<', '><');
                data[3] = emptyString;

                data[7] = '<div data-remove="from-card" class="btn btn-xs btn-danger btn-block" role="button"><i class="icon-trash icons"></i></div>';

                tableShoppingCard.row.add(data);
                // console.log(tableShoppingCard.rows().data())

            });

            tableShoppingCard.draw();
            initTableShoppingCard();

            removeTableRowFromCard();
            xEditable();

        })

    }

    function initDateTimePicker() {

        localDE();

        $(function() {
            $('#datetimepicker1').datetimepicker({
                locale: 'de',
                minDate: moment().add('d', 1).toDate(),
                format: 'DD.MM.YYYY',
                useCurrent: false
            });
        });
    }


    function xEditable() {


        $('[x-editable]').editable({
            showbuttons: false,
            onblur: 'submit',
            success: function(value) {

            }
        });

        xEditableSave();

    }

    function xEditableSave() {

        var currentElement, currentUnit, currentCell, currentRow, inputFormatted, priceTotalEl, singlePriceUnformatted, singlePriceFormatted, quantityUnformattd, quantityFormatted, sum, newData;

        $('[x-editable]').on('save', function(e, params) {

            /* Keeps the rest of the handlers from being executed and prevents the event from bubbling up the DOM tree 	*/
            e.stopImmediatePropagation();

            // preis berechnen, formatieren, ausgegeben
            currentElement = $(this);
            currentTable = getCurrentTable(currentElement);
            currentRow = currentTable.row($(this).closest('tr')).data();

            singlePriceUnformatted = currentElement.closest('td').prev().prev().text();
            singlePriceFormatted = removeAllNonDigits(singlePriceUnformatted);
            quantityUnformatted = params.newValue;
            quantityFormatted = removeAllNonDigits(quantityUnformatted);
            sum = (singlePriceFormatted * quantityFormatted).toFixed(2);
            priceTotalEl = currentElement.closest('td').next();

            console.log(singlePriceUnformatted);

            //  "Preis Gesamt" - füllen mit dataTable API
            currentTable.cell(priceTotalEl).data(replaceDotsToComma(sum + ' €'));

            // "Aktuelle Zelle" - hängt die einheit (Stück,KG, Eimer etc)an die aktuelle eingabe
            currentUnit = currentElement.data('unit');
            inputFormatted = removeAllNonDigits(params.newValue);

            // Eingabe Formatieren
            inputFormatted = parseFloat(inputFormatted).toFixed(2);

            // Ausgabe updaten
            newData = '<a href="#" x-editable data-type="text" class="editable editable-click editable-disabled" tabindex="-1" data-placeholder="Kg" data-unit="Kg"  data-emptytext="Menge in Kg">';
            newData += replaceDotsToComma(inputFormatted + ' ' + currentUnit);
            newData += '</a>';

            currentCell = currentElement.closest('td');
            currentTable.cell(currentCell).data(newData);

            // currentTable.draw()

            $('[x-editable]').editable('destroy');
            xEditable();


        });
    }

    function initTableShoppingCard() {

        // Warenkorb - global verfügbar
        window.tableShoppingCard = $('[data-table="shoppingcard"]').DataTable({
            responsive: true,
            retrieve: true,
            destroy: true,
            paging: false,
            searching: false,
            order: [],
            columnDefs: [{
                targets: 'no-sort',
                orderable: false
            }],
            language: {
                lengthMenu: "_MENU_  Artikel pro Seite",
                zeroRecords: "Nichts gefunden.",
                info: "Seite _PAGE_ von _PAGES_",
                infoEmpty: "Keine Produkte verfügbar",
                search: "Suchen",
                paginate: {
                    first: "Erste",
                    previous: "Zurück",
                    next: "Nächste",
                    last: "Letzte"
                }
            }
        });

        // test - wird ausgegeben wenn der warenkorb sich neu berechnet
        tableShoppingCard.on('draw', function() {

        });

    }

    function initTableMyProducts() {
        window.tableMyProducts = $('[data-table="myproducts"]').DataTable({
            responsive: true,
            pageLength: 10,
            destroy: true,
            order: [],
            columnDefs: [{
                targets: 'no-sort',
                orderable: false
            }],
            language: {
                lengthMenu: "_MENU_  Artikel pro Seite",
                zeroRecords: "Nichts gefunden.",
                info: "Seite _PAGE_ von _PAGES_",
                infoEmpty: "Keine Produkte verfügbar",
                search: "Suchen",
                paginate: {
                    first: "Erste",
                    previous: "Zurück",
                    next: "Nächste",
                    last: "Letzte"
                }
            }

        });
    }

    function initTableSpecialProducts() {
        window.tableSpecialProducts = $('[data-table="specialproducts"]').DataTable({
            responsive: true,
            pageLength: 10,
            destroy: true,
            order: [],
            columnDefs: [{
                targets: 'no-sort',
                orderable: false
            }],
            language: {
                lengthMenu: "_MENU_  Artikel pro Seite",
                zeroRecords: "Nichts gefunden.",
                info: "Seite _PAGE_ von _PAGES_",
                infoEmpty: "Keine Produkte verfügbar",
                search: "Suchen",
                paginate: {
                    first: "Erste",
                    previous: "Zurück",
                    next: "Nächste",
                    last: "Letzte"
                }
            }

        });
    }


    function initTableAllProducts() {
        window.tableAllProducts = $('[data-table="allproducts"]').DataTable({
            responsive: true,
            pageLength: 10,
            destroy: true,
            order: [],
            columnDefs: [{
                targets: 'no-sort',
                orderable: false
            }],
            language: {
                lengthMenu: "_MENU_  Artikel pro Seite",
                zeroRecords: "Nichts gefunden.",
                info: "Seite _PAGE_ von _PAGES_",
                infoEmpty: "Keine Produkte verfügbar",
                search: "Suchen",
                paginate: {
                    first: "Erste",
                    previous: "Zurück",
                    next: "Nächste",
                    last: "Letzte"
                }
            }
        });
    }

    function initTableLastProducts() {
        window.tableLastProducts = $('[data-table="lastproducts"]').DataTable({
            responsive: true,
            pageLength: 10,
            destroy: true,
            order: [],
            columnDefs: [{
                targets: 'no-sort',
                orderable: false
            }],
            language: {
                lengthMenu: "_MENU_  Artikel pro Seite",
                zeroRecords: "Nichts gefunden.",
                info: "Seite _PAGE_ von _PAGES_",
                infoEmpty: "Keine Produkte verfügbar",
                search: "Suchen",
                paginate: {
                    first: "Erste",
                    previous: "Zurück",
                    next: "Nächste",
                    last: "Letzte"
                }
            }

        });

        initAddAllToCardButton();

    }

    function removeTableRowFromCard() {

        $('[data-remove="from-card"]').off();
        $('[data-remove="from-card"]').click(function(event) {

            event.preventDefault()

            $this = $(this);
            tableShoppingCard.row($this.closest('tr')).remove().draw(false);

        });

    }

    function addTableRowToCard() {

        var dataOfPrevSumCell, currentButton, shoppingCardRowData;

        $(document).on('click', '[data-add="to-card"]', function(event) {

            event.preventDefault();
            event.stopPropagation();

            currentTable = getCurrentTable($(this))

            dataOfPrevSumCell = currentTable.cell($(this).closest('td').prev()).data();

            //  prüfen ob Summe leer ist (also keine Menge angegeben)
            if (dataOfPrevSumCell == '') {

                currentButton = $(this);
                $(currentButton).closest('td').prev().prev().addClass('empty-value');

                setTimeout(function() {
                    $(currentButton).closest('td').prev().prev().removeClass('empty-value');
                }, 3500)

            } else {

                // Daten zum Warenkorb hinzufügen
                shoppingCardRowData = currentTable.row($(this).closest('tr')).data();
                shoppingCardRowData[7] = '<div data-remove="from-card" class="btn btn-xs btn-danger btn-block" role="button"><i class="icon-trash icons"></i></div>'
                tableShoppingCard.row.add(shoppingCardRowData).draw();

                // Leert den Preis Gesamt
                currentTable.cell($(this).closest('td').prev()).data('');

                // Leert die Menge
                currentTable.cell($(this).closest('td').prev().prev()).data('<a href="#" x-editable data-type="text" class="editable editable-click editable-disabled" tabindex="-1" data-placeholder="Kg" data-unit="Kg"  data-emptytext="Menge in Kg">');

                xEditable();
                removeTableRowFromCard();


            } // end if dataOfPrevSumCell not emtpy

            tableShoppingCard.destroy();
            initTableShoppingCard();
            calcTotalPrice();

        });
    }


    function removeAllNonDigits(string) {
        string = string.replace(',', '.');

        return parseFloat(string);
    }

    function replaceDotsToComma(number) {
        number = number.replace('.', ',');
        return number;
    }

    function getCurrentTable(currentElement) {

        // dörty but works - findet anhand eines elements den bereits initialisierten dataTable
        var tableName = currentElement.closest('[data-table]').data('table');

        switch (tableName) {

            case 'myproducts':
                currentTable = tableMyProducts;
                break;
            case 'allproducts':
                currentTable = tableAllProducts;
                break;
            case 'lastproducts':
                currentTable = tableLastProducts;
                break;
            case 'specialproducts':
                currentTable = tableSpecialProducts;
                break;
            case 'shoppingcard':
                currentTable = tableShoppingCard;
                break;
            default:
                console.log('sorry, no known table selected')
        }

        return currentTable
    }

    function calcTotalPrice() {

        var netto,
            val, brutto, mwst = 1.07,
            netto;

        var sumNettoEl = $('[data-sum="netto"]');
        var sumMwstEl = $('[data-sum="mwst"]');
        var sumBruttoEl = $('[data-sum="brutto"]');

        netto = 0;
        tableShoppingCard.rows().every(function(rowIdx, tableLoop, rowLoop) {
            val = tableShoppingCard.column(6).data();
            val = removeAllNonDigits(val[rowIdx]);

            netto += val;
        });

        brutto = netto * mwst;

        netto = netto.toFixed(2);
        // mwst = (brutto - netto).toFixed(2);
        // brutto = brutto.toFixed(2);

        $(sumNettoEl).text(replaceDotsToComma(netto) + ' €');
        // $(sumMwstEl).text(replaceDotsToComma(mwst) + ' €');
        // $(sumBruttoEl).text(replaceDotsToComma(brutto) + ' €');

    }

    function getOrderData() {

        $('[data-select="last-orders"]').change(function() {
            var ordernum = $(this).val();
            $.ajax({
                url: fisheasy.ajax,
                type: 'POST',
                data: {
                    'action': 'lastOrder',
                    'ordernum': ordernum
                },
                success: function(data) {

                    $('[data-ajax="lastproducts"]').empty();
                    $('[data-ajax="lastproducts"]').html(data);

                    initTableLastProducts();

                },
                error: function(errorThrown) {}
            });
        });
    }

    function setOrderData() {
        $('[data-action="submit"]').click(function() {

            var deliverdate = jQuery('input[name="lieferdatum"]').val();

            if (deliverdate == '') {
                jQuery('input[name="lieferdatum"]').addClass('has-error');
            } else {
                jQuery('input[name="lieferdatum"]').removeClass('has-error');
            };


            var basket = new Array();
            tableShoppingCard.rows().every(function(rowIdx, tableLoop, rowLoop) {

                var productnum = tableShoppingCard.column(2).data();
                var quantity = tableShoppingCard.column(5).data();

                var entry = { productnum: productnum[rowIdx], quantity: removeAllNonDigits(stripHTML(quantity[rowIdx])), deliverdate: deliverdate };
                basket.push(entry);

            });

            if (deliverdate != "" && deliverdate != null) {
                $.ajax({
                    url: fisheasy.ajax,
                    type: 'POST',
                    data: {
                        'action': 'sendOrder',
                        'data': basket
                    },
                    success: function(data) {

                        $('[data-status]').empty();
                        $('[data-status]').html(data);

                        // leert Warenkorb und zeichnet Tabelle Neu
                        tableShoppingCard.clear().draw();

                        // setz summe auf null
                        jQuery('[data-sum="netto"]').text('0,00 €');
                        // jQuery('[data-sum="mwst"]').text('0,00 €');
                        // jQuery('[data-sum="brutto"]').text('0,00 €');



                    },
                    error: function(errorThrown) {}
                });
            } else {
                alert('Bitte geben Sie ein Lieferdatum an!');
            }

        });
    }

    function stripHTML(string) {
        var tmp = document.createElement("div");
        tmp.innerHTML = string;
        return tmp.textContent || tmp.innerText || '';
    }

    function localDE() {

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
            var format = {
                'm': ['eine Minute', 'einer Minute'],
                'h': ['eine Stunde', 'einer Stunde'],
                'd': ['ein Tag', 'einem Tag'],
                'dd': [number + ' Tage', number + ' Tagen'],
                'M': ['ein Monat', 'einem Monat'],
                'MM': [number + ' Monate', number + ' Monaten'],
                'y': ['ein Jahr', 'einem Jahr'],
                'yy': [number + ' Jahre', number + ' Jahren']
            };
            return withoutSuffix ? format[key][0] : format[key][1];
        }

        var de = moment.defineLocale('de', {
            months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
            monthsShort: 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
            monthsParseExact: true,
            weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
            weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
            weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY HH:mm',
                LLLL: 'dddd, D. MMMM YYYY HH:mm'
            },
            calendar: {
                sameDay: '[heute um] LT [Uhr]',
                sameElse: 'L',
                nextDay: '[morgen um] LT [Uhr]',
                nextWeek: 'dddd [um] LT [Uhr]',
                lastDay: '[gestern um] LT [Uhr]',
                lastWeek: '[letzten] dddd [um] LT [Uhr]'
            },
            relativeTime: {
                future: 'in %s',
                past: 'vor %s',
                s: 'ein paar Sekunden',
                m: processRelativeTime,
                mm: '%d Minuten',
                h: processRelativeTime,
                hh: '%d Stunden',
                d: processRelativeTime,
                dd: processRelativeTime,
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: '%d.',
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.
            }
        });

        return de;
    }




})(jQuery);